import { AccountActionLogServiceData } from 'types/account/log/account-log';
import { SortParams } from 'types/common/sorting';
import { FetchAction } from 'types/services/redux-action';
import { FetchReducer, SortState } from 'types/services/redux-state';

export const FETCH_ACTIVITY_IS_COMPLETE = 'FETCH_ACTIVITY';

export const FETCH_ACTIVITY_IS_PENDING = 'FETCH_ACTIVITY_IS_PENDING';

export const FETCH_ACTIVITY_IS_ERROR = 'FETCH_ACTIVITY_IS_ERROR';

export const SORT = 'SORT_ACTIVITY_LOG';

export type ActivityLogReducerState = { activityLog: AccountActionLogServiceData[] } & FetchReducer<'activity'> &
  SortState<AccountActionLogServiceData>;

export type ActivityLogActions =
  | FetchAction<'FETCH_ACTIVITY', AccountActionLogServiceData[]>
  | { type: 'SORT_ACTIVITY_LOG'; params: SortParams<AccountActionLogServiceData> };
